import {
  CREATE_OUTLET_FAILD,
  CREATE_OUTLET_LOADING,
  CREATE_OUTLET_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  outlet: null,
  status: null,
};

export const addOutletReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case CREATE_OUTLET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CREATE_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        outlet: action.payload,
        status: action.status,
        error: null,
      };
    case CREATE_OUTLET_FAILD:
      return {
        ...state,
        loading: false,
        outlet: null,
        status: null,
        error: action.error,
      };
    default:
      return state;
  }
};
